import React from 'react'
import ClickOutside from 'react-click-outside'
import {MdClose} from 'react-icons/md'
import useDisableScroll from '@hooks/useDisableScroll'
interface Props {
  title?: string
  children?: React.ReactNode
  onClose?: () => void
  open?: boolean
  canClickOutside?: boolean
}

export default function SideModal(props: Props) {
  const {title, onClose, open, children, canClickOutside = true} = props
  useDisableScroll(open)

  if (!open) return null

  const onClickOutside = () => {
    if (
      !canClickOutside ||
      document.getElementById('close-modal-product') ||
      document.getElementById('v3_modal')
    ) {
      // This is hacky, but couldn't think of a better way to prevent the click outside when there are two modals open
      return
    }
    onClose()
  }

  return (
    <div
      className="relative z-[1100]"
      aria-labelledby="slide-over-title"
      role="dialog"
      aria-modal="true">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
            <div className="pointer-events-auto relative w-screen max-w-md">
              <ClickOutside
                onClickOutside={onClickOutside}
                className="flex h-screen flex-col bg-white dark:bg-zinc-800 px-6 py-6 shadow-xl">
                <div className="flex flex-row justify-between">
                  <h2 className="text-2xl font-semibold" id="slide-over-title">
                    {title}
                  </h2>
                  <button className="cursor-pointer" aria-label="Close button" onClick={onClose}>
                    <MdClose size={24} />
                  </button>
                </div>
                {children}
              </ClickOutside>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
